module.exports = __webpack_public_path__ + "img/Other.7ece5cba.svg";